<template>
  <div class="goal-image-preview">
    <div v-if="goalImage"
         @click.stop="$emit('toggleImagePicker')">
      <img :src="goalImage" alt="">
      <div class="edit-icon group" @click.stop="$emit('toggleImagePicker')">
        <IconEdit class="text-white group-hover:text-red transition duration-200"/>
      </div>
    </div>
    <div v-else class="goal-image-preview__empty"
         @click.stop="$emit('toggleImagePicker')">
      <IconImage class="text-border-hover lg:mr-7"/>
      <div class="text-md text-text-label">{{ $t('selectAnImage') }}</div>
    </div>
  </div>
</template>

<script>
import IconEdit from "@/components/icons/IconEdit";
import IconImage from "@/components/icons/IconImage";
import {mapGetters} from "vuex";

export default {
  name: "GoalImagePickerPreview",
  components: {IconImage, IconEdit},
  props: {
    goalImage: {
      type: String
    }
  },
  i18n: {
    messages: {
      en: {
        selectAnImage: 'Select an image'
      },
      ru: {
        selectAnImage: 'Выберите изображение'
      },
    }
  }
}
</script>
<style lang="scss">
.goal-image-preview {
  @apply mb-12 w-full cursor-pointer relative;

  img {
    @apply rounded;
    width: 100%;
    height: 150px;
    object-fit: cover;
  }

  &__empty {
    @apply bg-white flex items-center justify-center rounded;
    height: 150px;
  }

  .edit-icon {
    @apply bg-black-transparent80 rounded absolute right-4 bottom-4 flex items-center justify-center;
    width: 2.5rem;
    height: 2.5rem;
  }

  @media(max-width: 1199px) {
    &__empty {
      @apply flex-wrap;
      > div {
        @apply w-full text-center;
      }
    }
  }
}
</style>